export const scrollToTop = () => {
  window.scrollTo({
    behavior: "smooth",
    top: 0,
  });
};
